import Vue from 'vue'
import Vuex from 'vuex'
import Token from './modules/token'
import User from './modules/user'
import Register from './modules/register'
import Cardmachine from './modules/cardmachine'
import Cardmachinerecord from './modules/cardmachinerecord'
import M4backup from './modules/m4backup'
import Appaccount from './modules/appaccount'
import Appblelock from './modules/appblelock'
import Appblelockrecord from './modules/appblelockrecord'
import Goods from './modules/goods'
import Goodstemplate from './modules/goodstemplate'
import Goodsvalue from './modules/goodsvalue'
import Goodsorder from './modules/goodsorder'
import Persistedstate from 'vuex-persistedstate'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
    RESET_ALL_STATE(context) {
      //console.log('RESET_ALL_STATE',this)
      this.commit('Token/CLEAR_TOKEN', null, { root: true });
      this.commit('User/CLEAR_USERINFO', null, { root: true });
      this.commit('Register/CLEAR_REGISTERLIST1', null, { root: true });
      this.commit('Cardmachine/CLEAR_CARDMACHINELIST', null, { root: true });
      this.commit('Cardmachinerecord/CLEAR_CARDMACHINERECORDLIST', null, { root: true });
      this.commit('M4backup/CLEAR_M4BACKUPLIST', null, { root: true });
      this.commit('Appaccount/CLEAR_APPACCOUNTLIST', null, { root: true });
      this.commit('Appblelock/CLEAR_APPBLELOCKLIST', null, { root: true });
      this.commit('Appblelockrecord/CLEAR_APPBLELOCKRECORDLIST', null, { root: true });
      this.commit('Goods/CLEAR_GOODSLIST', null, { root: true });
      this.commit('Goodstemplate/CLEAR_GOODSTEMPLATELIST', null, { root: true });
      this.commit('Goodsvalue/CLEAR_GOODSVALUELIST', null, { root: true });
      this.commit('Goodsorder/CLEAR_GOODSORDER', null, { root: true });
      
      
    }

  },
  actions: {
  },
  modules: {
    Token,
    User,
    Register,
    Cardmachine,
    Cardmachinerecord,
    M4backup,
    Appaccount,
    Appblelock,
    Appblelockrecord,
    Goods,
    Goodstemplate,
    Goodsvalue,
    Goodsorder
  },
  plugins: [
    Persistedstate({
      key: 'jc',
      paths: ['Token']
    })
  ]
})
